import { ActionTree } from "vuex";
import { AppHookCodes } from "@/data/enums/hooks";
import { IState } from "@/store";
import { IUser } from "@/models/users";

const initialState = () => ({});

const actions: ActionTree<{}, IState> = {
  [AppHookCodes.ADMIN_USER_LOGGED_IN]: async (
    { dispatch, rootState },
    user: IUser
  ) => {
    await dispatch("ui/userflow/tryInit", user, { root: true });
    /** Here we check if the current brand has a demo data import_id, and
     * initiate a check to see if the import is complete or in progress */
    if (rootState.brand?.demo_data_import_id)
      dispatch("demoData/checkImportStatus", null, { root: true });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions
};
